import React, { useEffect, useState } from "react";
import Modal from "react-animated-modal";
import { getLicensingTerms } from "../../services/Management/LicensingService";
import LicenseTermItem from "./LicenseTermItem";
import CustomScroll from "react-custom-scroll";

function LicenseTermsModal(props) {
  const [licenseTerms, setLicenseTerms] = useState([]);

  useEffect(() => {
    getLicensingTerms().then((res) => {
      setLicenseTerms(res);
    });
  }, []);

  return (
    <Modal visible={true} type="fadeIn" closemodal={props.openCloseModal}>
      <div className="modal" role="dialog">
        <div className="license-term-modal">
          <div className="modal" tabIndex="-1" role="dialog">
            <div className="modal-dialog" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">{props._.Licenses}</h5>
                  <button className="btn">
                    <i
                      className="icon-omni-close-circle"
                      onClick={props.openCloseModal}
                    />
                  </button>
                </div>
                <CustomScroll
                  heightRelativeToParent="50%"
                  allowOuterScroll={false}
                >
                  <div className="modal-body">
                    {licenseTerms.map((license) => (
                      <LicenseTermItem
                        key={license.id}
                        item={license}
                        _={props._}
                      />
                    ))}
                  </div>
                </CustomScroll>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
}

export default LicenseTermsModal;
